import React from 'react';
import Support from '../../shared/Support';
import useSessionEntity from '../../../hooks/useSessionEntity';

export default function ExpiredLink() {
  const merchant = useSessionEntity('merchant');

  return (
    <div className="text-center" id="content">
      <h1 className="font-avenir-medium text-navy-blue text-2xl">This link has expired</h1>
      <p>
        Please ask your {merchant?.name} rep to create a new Credit Key order,
        if needed.
      </p>

      <Support />
    </div>
  );
}
